import { isEmpty, isNil } from 'lodash';

import { IListingCadastralDateForm } from '../ListingCadastralDataForm.types';

type IListingCadastralDateFormKey = keyof IListingCadastralDateForm;

const RequiredFieldForTenants: {
  label: string;
  value: IListingCadastralDateFormKey;
}[] = [
  { label: 'listingDetail:foglio', value: 'cadastral_sheet' },
  {
    label: 'listingDetail:particella',
    value: 'cadastral_parcel',
  },
  { label: 'listingDetail:subalterno', value: 'cadastral_subordinate' },
  { label: 'listingDetail:cadastralCategory', value: 'cadastral_category' },
  { label: 'listingDetail:cadastralIncome', value: 'cadastral_income' },
];

export const filterRequiredFieldForCadastralInformation = ({
  values,
}: {
  values: IListingCadastralDateForm;
}) => {
  const emptyFields = RequiredFieldForTenants.filter(field => {
    if (field.value === 'cadastral_income') {
      return !Number(values['cadastral_income']);
    }
    return isEmpty(values[field.value]) || isNil(values[field.value]);
  }).map(field => field.label);

  const label = 'listingDetail:cadastralInfo';

  return {
    label,
    fields: emptyFields,
  };
};
